var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "header_wrap" }, [
        _c(
          "div",
          { staticStyle: { width: "60%" } },
          [
            _c(
              "el-steps",
              {
                staticStyle: { width: "100%" },
                attrs: { "align-center": "", active: 0 }
              },
              [
                _c("el-step", {
                  attrs: {
                    title:
                      _vm.transportTypeCode == "KY"
                        ? _vm.$t("i18n_Air_Freight_Information")
                        : _vm.transportTypeCode == "HY"
                        ? _vm.$t("i18n_ocean_freight_information")
                        : _vm.transportTypeCode == "LY"
                        ? _vm.$t("i18n_land_transportation_information")
                        : ""
                  }
                }),
                _vm._v(" "),
                _c("el-step", {
                  attrs: { title: _vm.$t("i18n_Value_added_service") }
                }),
                _vm._v(" "),
                _c("el-step", {
                  attrs: { title: _vm.$t("i18n_shipping_information") }
                }),
                _vm._v(" "),
                _c("el-step", {
                  attrs: { title: _vm.$t("i18n_confirm_order") }
                }),
                _vm._v(" "),
                _c("el-step", {
                  attrs: { title: _vm.$t("i18n_order_completed") }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "center_wrap" }, [
        _c("div", { staticClass: "wrap_l" }, [
          _c("div", { staticClass: "Item_list" }, [
            _c(
              "div",
              {
                staticClass: "cangkutit",
                staticStyle: { "margin-right": "50px" }
              },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.fromFABck.namec) + "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "cangkutit",
                staticStyle: { "margin-right": "50px" }
              },
              [
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.transportTypeCode == "KY",
                      expression: "transportTypeCode=='KY'"
                    }
                  ],
                  staticStyle: { width: "60px" },
                  attrs: {
                    src: require("../../../static/images/KY.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.transportTypeCode == "HY",
                      expression: "transportTypeCode=='HY'"
                    }
                  ],
                  staticStyle: { width: "60px" },
                  attrs: {
                    src: require("../../../static/images/HY.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.transportTypeCode == "LY",
                      expression: "transportTypeCode=='LY'"
                    }
                  ],
                  staticStyle: { width: "60px" },
                  attrs: {
                    src: require("../../../static/images/LY.png"),
                    alt: ""
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "cangkutit" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.toFABck.country) + "\n          "
              ),
              _c("span", { staticStyle: { "font-size": "14px" } }, [
                _vm._v(_vm._s(_vm.toFABck.namec))
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.finalDeliveryArray.length > 0
            ? _c("div", { staticClass: "Item_list send_end" }, [
                _c(
                  "div",
                  { staticStyle: { width: "100%", "margin-bottom": "20px" } },
                  [_vm._v("尾程派送方式")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "send_end_content" },
                  _vm._l(_vm.finalDeliveryArray, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "send_content_secItem" },
                      [
                        _c("div", { staticClass: "send_item_left" }, [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "send_item_two" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    staticStyle: { border: "none !important" },
                                    attrs: {
                                      effect: "light",
                                      content: item.deliveryServiceRule,
                                      placement: "top"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-link",
                                      {
                                        attrs: {
                                          type: "primary",
                                          underline: false
                                        }
                                      },
                                      [_vm._v("计费规则")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  color: "#606266",
                                  "font-weight": "500"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  计费标准:" +
                                    _vm._s(item.chargeUnit) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "send_left_one" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(item.deliveryService) +
                                ":\n                "
                            ),
                            _c("div", { staticStyle: { color: "#f86670" } }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(item.price ? item.price : 0) +
                                  "\n                "
                              )
                            ]),
                            _vm._v(
                              "\n                " +
                                _vm._s(item.currency) +
                                "\n              "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "send_item_right" },
                          [
                            _c("el-checkbox", {
                              attrs: { disabled: "" },
                              on: {
                                change: function($event) {
                                  return _vm.watchCheck(item)
                                }
                              },
                              model: {
                                value: item.checked,
                                callback: function($$v) {
                                  _vm.$set(item, "checked", $$v)
                                },
                                expression: "item.checked"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "demoLIst" }, [
            _c(
              "div",
              { staticStyle: { width: "98%", float: "left" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "LR_center",
                    staticStyle: {
                      "font-size": "18px",
                      "margin-top": "24px",
                      width: "100%",
                      "font-weight": "bold"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-flow": "row nowrap",
                          "align-items": "center"
                        }
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "20px", height: "22px" },
                          attrs: {
                            src: require("../../assets/boxicon.png"),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticStyle: { "margin-left": "10px" } }, [
                          _vm._v(_vm._s(_vm.$t("i18n_product_information")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              "close-on-click-modal": false
                            },
                            on: {
                              click: function($event) {
                                ;(_vm.excelVisible = true),
                                  (_vm.errorLabel = []),
                                  (_vm.isNewUpload = true)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("i18n_Importing_boxes")) +
                                "(" +
                                _vm._s(_vm.$t("i18n_By_summary")) +
                                ")"
                            ),
                            _c("i", {
                              staticClass: "el-icon-upload el-icon--right"
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              "close-on-click-modal": false
                            },
                            on: {
                              click: function($event) {
                                ;(_vm.excelVisible = true),
                                  (_vm.errorLabel = []),
                                  (_vm.isNewUpload = false)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("i18n_Importing_boxes")) +
                                "(" +
                                _vm._s(_vm.$t("i18n_By_detail")) +
                                ")"
                            ),
                            _c("i", {
                              staticClass: "el-icon-upload el-icon--right"
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "ruleform",
                    staticClass: "demo-dynamic",
                    attrs: {
                      "label-position": "left",
                      size: "mini",
                      model: _vm.ruleform
                    }
                  },
                  _vm._l(_vm.ruleform.formLIst, function(item, index) {
                    return _c("div", { key: index, staticClass: "cardWrap" }, [
                      _c("div", { staticClass: "box-card" }, [
                        _c("div", { staticClass: "card_header" }, [
                          _c("div", { staticClass: "boxindex" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(index + 1) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "header_logo",
                              staticStyle: { cursor: "pointer" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cloneType",
                                  on: {
                                    click: function($event) {
                                      return _vm.clone(item)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.$t("i18n_Copy")) +
                                      "\n                    "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.ruleform.formLIst.length > 1
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "deleteBtn",
                                      on: {
                                        click: function($event) {
                                          return _vm.handleDelete(index, item)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "el-icon-error" })]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {},
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 5 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "rules",
                                              attrs: {
                                                label: _vm.$t("i18n_size_cm"),
                                                "label-width": "86px",
                                                prop:
                                                  "formLIst." +
                                                  index +
                                                  ".length",
                                                rules: _vm.moreNotOjb.Notlength
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "i18n_length1"
                                                  ),
                                                  size: "mini",
                                                  min: 0,
                                                  max: 9999
                                                },
                                                on: {
                                                  change: function($event) {
                                                    _vm.getTimoney(index),
                                                      _vm.getFBATrans(index),
                                                      _vm.getCheckGlobalDelivery(
                                                        index
                                                      )
                                                  }
                                                },
                                                model: {
                                                  value: item.length,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "length",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.length"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "rules",
                                              attrs: {
                                                "label-width": "5px",
                                                prop:
                                                  "formLIst." +
                                                  index +
                                                  ".width",
                                                rules: _vm.moreNotOjb.Notwidth
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "i18n_wide1"
                                                  ),
                                                  size: "mini",
                                                  min: 0,
                                                  max: 9999
                                                },
                                                on: {
                                                  change: function($event) {
                                                    _vm.getTimoney(index),
                                                      _vm.getFBATrans(index),
                                                      _vm.getCheckGlobalDelivery(
                                                        index
                                                      )
                                                  }
                                                },
                                                model: {
                                                  value: item.width,
                                                  callback: function($$v) {
                                                    _vm.$set(item, "width", $$v)
                                                  },
                                                  expression: "item.width"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "rules",
                                              attrs: {
                                                "label-width": "5px",
                                                prop:
                                                  "formLIst." +
                                                  index +
                                                  ".height",
                                                rules: _vm.moreNotOjb.Notheight
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "i18n_height1"
                                                  ),
                                                  size: "mini",
                                                  min: 0,
                                                  max: 9999
                                                },
                                                on: {
                                                  change: function($event) {
                                                    _vm.getTimoney(index),
                                                      _vm.getFBATrans(index),
                                                      _vm.getCheckGlobalDelivery(
                                                        index
                                                      )
                                                  }
                                                },
                                                model: {
                                                  value: item.height,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "height",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.height"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("el-col", { attrs: { span: 5 } }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "LR_center",
                                        staticStyle: {
                                          "font-size": "12px",
                                          "font-weight": "bold",
                                          "text-align": "left",
                                          "margin-top": "8px"
                                        }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#f86670" }
                                            },
                                            [_vm._v(_vm._s(item.cbm))]
                                          ),
                                          _vm._v(
                                            "\n                            CBM\n                          "
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card_count" },
                          [
                            _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "rules",
                                        attrs: {
                                          "label-width": "78px",
                                          label: _vm.$t("i18n_FBA_number"),
                                          rules: _vm.moreNotOjb.Notboxnum,
                                          prop:
                                            "formLIst." + index + ".fbxBoxNo"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            attrs: {
                                              maxlength: _vm.maxlength,
                                              type: "text",
                                              placeholder: _vm.billType
                                                ? _vm.$t("i18n_fba_example")
                                                : _vm.addPls(
                                                    "i18n_FBA_number",
                                                    "input"
                                                  ),
                                              size: "mini"
                                            },
                                            model: {
                                              value: item.fbxBoxNo,
                                              callback: function($$v) {
                                                _vm.$set(item, "fbxBoxNo", $$v)
                                              },
                                              expression: "item.fbxBoxNo"
                                            }
                                          },
                                          [
                                            _vm.billType
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      slot: "suffix",
                                                      type: "text"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        ;(_vm.imageNum = 1),
                                                          (_vm.imagesType = true)
                                                      }
                                                    },
                                                    slot: "suffix"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "i18n_Example_diagram"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "rules",
                                        attrs: {
                                          "label-width": "95px",
                                          label: _vm.$t("i18n_weight"),
                                          prop: "formLIst." + index + ".weight",
                                          rules: _vm.moreNotOjb.Notweight
                                        }
                                      },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            attrs: {
                                              size: "mini",
                                              min: 0,
                                              max: 999,
                                              placeholder: _vm.addPls(
                                                "i18n_weight",
                                                "input"
                                              )
                                            },
                                            on: {
                                              change: function($event) {
                                                _vm.getTimoney(),
                                                  _vm.getFBATrans(index),
                                                  _vm.getCheckGlobalDelivery()
                                              }
                                            },
                                            model: {
                                              value: item.weight,
                                              callback: function($$v) {
                                                _vm.$set(item, "weight", $$v)
                                              },
                                              expression: "item.weight"
                                            }
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                attrs: { slot: "suffix" },
                                                slot: "suffix"
                                              },
                                              [_vm._v("(KG)")]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _vm.billType && _vm.toFABck.countryCode == "SA"
                                  ? _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "rules",
                                            attrs: {
                                              "label-width": "95px",
                                              label: _vm.$t(
                                                "i18n_Amazon_Reference_Number_PO"
                                              ),
                                              prop:
                                                "formLIst." +
                                                index +
                                                ".poTrackingNo",
                                              rules: _vm.moreNotOjb.Notponum
                                            }
                                          },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  maxlength: "8",
                                                  placeholder: _vm.$t(
                                                    "i18n_reference_example"
                                                  )
                                                },
                                                model: {
                                                  value: item.poTrackingNo,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "poTrackingNo",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.poTrackingNo"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      slot: "suffix",
                                                      type: "text"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        ;(_vm.imageNum = 2),
                                                          (_vm.imagesType = true)
                                                      }
                                                    },
                                                    slot: "suffix"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "i18n_Example_diagram"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "100%",
                              padding: "5px 20px",
                              "box-sizing": "border-box"
                            }
                          },
                          [
                            _c(
                              "el-collapse",
                              {
                                staticStyle: { width: "100%" },
                                on: {
                                  change: function($event) {
                                    return _vm.handleOPen(index)
                                  }
                                },
                                model: {
                                  value: _vm.activeName,
                                  callback: function($$v) {
                                    _vm.activeName = $$v
                                  },
                                  expression: "activeName"
                                }
                              },
                              [
                                _c(
                                  "el-collapse-item",
                                  { attrs: { name: index } },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _c("i", { staticClass: "el-icon-coin" }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-left": "15px",
                                            "font-size": "13px",
                                            "font-weight": "bold"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("i18n_product_number", {
                                                num: item.goodsDTOList.length
                                              })
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "el-icon-info",
                                          staticStyle: {
                                            "margin-left": "30px",
                                            "font-size": "12px",
                                            color: "#999"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "i18n_provide_accurate_quantity_value"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-left": "30px",
                                            "font-size": "12px",
                                            color: "#f86670"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                          货值数据具有法律效应,请认真填写\n                        "
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(item.goodsDTOList, function(
                                      _item,
                                      _index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: _index,
                                          staticClass: "goodLi",
                                          staticStyle: { width: "100%" },
                                          on: {
                                            click: function($event) {
                                              return _vm.clickme(_item)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticStyle: { width: "30px" } },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-shopping-cart-1",
                                                staticStyle: {
                                                  "font-size": "18px"
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "box-sizing": "border-box",
                                                width: "170px",
                                                overflow: "hidden",
                                                color: "#999999",
                                                "font-weight": "bold",
                                                "font-size": "12px",
                                                "min-width": "170px",
                                                "white-space": "nowrap",
                                                "word-break": "break-all",
                                                "text-overflow": "ellipsis",
                                                "padding-right": "45px"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    width: "100px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_item.namec) + " "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "10px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(_item.namee) +
                                                      ")"
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "handNumber",
                                              staticStyle: {
                                                "margin-left": "10px"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "numName",
                                                  staticStyle: { color: "#999" }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("i18n_quantity")
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-input",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "number",
                                                    minlength: "1",
                                                    maxLength: "9",
                                                    oninput:
                                                      "if(isNaN(value)) { value = null } if(value<=0) {value=null} if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                                                  },
                                                  model: {
                                                    value: _item.num,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _item,
                                                        "num",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression: "_item.num"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-input__icon el-icon-plus",
                                                    attrs: { slot: "suffix" },
                                                    on: {
                                                      click: function($event) {
                                                        _item.num += 1
                                                      }
                                                    },
                                                    slot: "suffix"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-input__icon el-icon-minus",
                                                    attrs: { slot: "prefix" },
                                                    on: {
                                                      click: function($event) {
                                                        ;(_item.num -= 1),
                                                          _item.num <= 1
                                                            ? (_item.num = 1)
                                                            : ""
                                                      }
                                                    },
                                                    slot: "prefix"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "goodsValue",
                                              staticStyle: {
                                                "margin-left": "20px",
                                                position: "relative"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: { color: "#999" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            单个sku货值(USD)\n                          "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("el-input", {
                                                staticStyle: {
                                                  width: "150px",
                                                  border: "none"
                                                },
                                                attrs: {
                                                  type: "number",
                                                  min: 0,
                                                  size: "mini",
                                                  placeholder: _vm.$t(
                                                    "i18n_product_value1"
                                                  )
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.changeProValue(
                                                      _item,
                                                      _item.declaredValue
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: _item.declaredValue,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _item,
                                                      "declaredValue",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "_item.declaredValue"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-left": "20px",
                                                display: "flex"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticClass: "el-icon-delete",
                                                  staticStyle: {
                                                    color: "#f86670",
                                                    "margin-right": "10px"
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    size: "mini"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.delBoxgood(
                                                        index,
                                                        _index
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("i18n_delete")
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    slot: "trigger",
                                                    type: "text"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.showPictureManage(
                                                        index,
                                                        _index
                                                      )
                                                    }
                                                  },
                                                  slot: "trigger"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "i18n_Image_manage"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _item.goodsUrl
                                                ? _c(
                                                    "el-popover",
                                                    {
                                                      attrs: {
                                                        placement: "right",
                                                        width: "200",
                                                        trigger: "click"
                                                      }
                                                    },
                                                    [
                                                      _c("el-image", {
                                                        attrs: {
                                                          src: _item.goodsUrl
                                                            ? _item.goodsUrl
                                                            : ""
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          staticStyle: {
                                                            "margin-left":
                                                              "10px"
                                                          },
                                                          attrs: {
                                                            slot: "reference",
                                                            type: "text"
                                                          },
                                                          slot: "reference"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "i18n_Preview"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "addStyle" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "border-radius": "2px" },
                                    attrs: {
                                      plain: "",
                                      icon: "el-icon-circle-plus-outline",
                                      size: "mini",
                                      circle: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.changegoods(index)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("i18n_Select_product"))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  }),
                  0
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "TB_center",
                staticStyle: { width: "100%", float: "left", padding: "30px" }
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { "border-radius": "20px" },
                    attrs: { type: "primary", size: "medium" },
                    on: {
                      click: function($event) {
                        return _vm.addItem("ruleform")
                      }
                    }
                  },
                  [_vm._v("+" + _vm._s(_vm.$t("i18n_New_box")))]
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wrap_R", class: _vm.auto_fixed ? "auto_fixed" : "" },
          [
            _c(
              "p",
              {
                staticStyle: {
                  "font-size": "16px",
                  "font-family": "PingFang SC",
                  "font-weight": "500",
                  color: "#343434"
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("i18n_cost_calculation")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "Item_Right animate__animated animate__bounceInRight"
              },
              [
                _c("p", { staticClass: "tit" }, [
                  _vm._v(_vm._s(_vm.$t("i18n_shipping_cost")))
                ]),
                _vm._v(" "),
                _vm._l(_vm.FBATransmoney.goodsTypeFeeDTOS, function(
                  item,
                  index
                ) {
                  return _c("p", { key: index, staticClass: "coutText" }, [
                    _c("span", { staticClass: "littit" }, [
                      _vm._v(_vm._s(item.goodsTypeName))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fontString" }, [
                      _vm._v(_vm._s(item.currency) + _vm._s(item.amount))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v("(" + _vm._s(item.calDesc) + ")")
                    ])
                  ])
                }),
                _vm._v(" "),
                _c("p", { staticClass: "coutText" }, [
                  _c("span", { staticClass: "littit" }, [
                    _vm._v(_vm._s(_vm.$t("i18n_subtotal")))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fontString" }, [
                    _vm._v(
                      _vm._s(_vm.FBATransmoney.currency) +
                        _vm._s(_vm.FBATransmoney.amount)
                    )
                  ])
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.THFdata.checked,
                    expression: "THFdata.checked"
                  }
                ],
                staticClass:
                  "Item_Right animate__animated animate__bounceInRight"
              },
              [
                _c("p", { staticClass: "tit" }, [
                  _vm._v(_vm._s(_vm.$t("i18n_pickup_fee")))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "coutText" }, [
                  _c("span", { staticClass: "littit" }, [
                    _vm._v(_vm._s(_vm.$t("i18n_pickup_at_original_port")))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fontString" }, [
                    _vm._v(
                      _vm._s(_vm.THFdata.currency) + _vm._s(_vm.THFdata.amount)
                    )
                  ]),
                  _vm._v(" "),
                  _vm.THFdata.maxKilometer > 0
                    ? _c(
                        "span",
                        {
                          staticClass: "littit",
                          staticStyle: { float: "left", width: "100%" }
                        },
                        [
                          _vm._v(
                            "(" +
                              _vm._s(_vm.THFdata.minKilometer) +
                              "--" +
                              _vm._s(_vm.THFdata.maxKilometer) +
                              ")\n            " +
                              _vm._s(_vm.$t("i18n_Kilometers"))
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "Item_Right" }, [
              _c(
                "p",
                {},
                [
                  _c("span", { staticClass: "littit" }, [
                    _vm._v(_vm._s(_vm.$t("i18n_Total_payment")))
                  ]),
                  _vm._v(" "),
                  _vm._l(this.newArray, function(item, index) {
                    return _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.amount > 0,
                            expression: "item.amount > 0"
                          }
                        ],
                        key: index
                      },
                      [
                        _c("span", [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.currency != "",
                                  expression: "item.currency != ''"
                                }
                              ],
                              staticClass: "fontString",
                              staticStyle: { "padding-left": "10px" }
                            },
                            [_vm._v(_vm._s(item.currency))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.amount > 0,
                                  expression: "item.amount > 0"
                                }
                              ],
                              staticClass: "fontString",
                              staticStyle: {
                                "margin-left": "5px",
                                "margin-right": "5px"
                              }
                            },
                            [_vm._v(_vm._s(item.amount))]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  index == _vm.newArray.length - 1
                                    ? false
                                    : true,
                                expression:
                                  "index == newArray.length - 1 ? false : true"
                              }
                            ]
                          },
                          [_vm._v("+")]
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("p", { staticClass: "coutText" }, [
                _c("span", { staticClass: "littit" }, [
                  _vm._v(_vm._s(_vm.$t("i18n_Covert_to_CNY")))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "fontString" }, [
                  _vm._v("CNY " + _vm._s(_vm.calculatePrice))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "goodsValueCount" }, [
              _c("div", { staticClass: "goodsValue_name" }, [
                _vm._v("货值统计")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "goodsValue_fat" }, [
                _c("div", { staticClass: "goodsValue_box" }, [
                  _vm._v("箱数:" + _vm._s(_vm.getBoxNum) + " 箱")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "goodsValue_value" }, [
                  _vm._v("货值:" + _vm._s(_vm.getGoodsValue) + " USD")
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  "margin-top": "130px",
                  float: "left"
                }
              },
              [
                _c(
                  "div",
                  { staticStyle: { width: "100%" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { width: "100%" },
                        on: {
                          click: function($event) {
                            return _vm.pathToback()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("i18n_Previousstep")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { width: "100%", "margin-top": "10px" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: {
                          width: "100%",
                          background: "#5ab53c",
                          color: "#ffffff"
                        },
                        on: {
                          click: function($event) {
                            return _vm.pathToNext("ruleform")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("i18n_Next_step")))]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showMydialog
        ? _c(
            "div",
            {
              staticClass: "dialogCover",
              on: {
                click: function($event) {
                  if ($event.target !== $event.currentTarget) {
                    return null
                  }
                  return _vm.closeMyDialog()
                }
              }
            },
            [
              _c("div", { staticClass: "myDialog" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between"
                    }
                  },
                  [
                    _c("span", { staticStyle: { "font-weight": "600" } }, [
                      _vm._v(_vm._s(_vm.$t("i18n_pickup_address")))
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "el-icon-close",
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function($event) {
                          return _vm.closeMyDialog()
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          margin: "20px 0"
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-input",
                              {
                                staticStyle: { width: "450px" },
                                attrs: {
                                  clearable: "",
                                  placeholder: _vm.$t(
                                    "i18n_name_or_phone_number"
                                  ),
                                  size: "medium"
                                },
                                on: {
                                  clear: function($event) {
                                    return _vm.getPeopletable()
                                  }
                                },
                                nativeOn: {
                                  keyup: function($event) {
                                    return _vm.searchNameOrPhone($event)
                                  }
                                },
                                model: {
                                  value: _vm.nameOrPhone,
                                  callback: function($$v) {
                                    _vm.nameOrPhone = $$v
                                  },
                                  expression: "nameOrPhone"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-input__icon el-icon-search",
                                  attrs: { slot: "prefix" },
                                  slot: "prefix"
                                }),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { slot: "append", type: "primary" },
                                    slot: "append"
                                  },
                                  [_vm._v(_vm._s(_vm.$t("i18n_Search")))]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "medium",
                              plain: "",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.showAdd(true)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("i18n_Create_new_address")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.edit
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "background-color": "#fff",
                              "border-radius": "20px",
                              padding: "20px",
                              "box-shadow":
                                "0px 0px 20px 0px rgba(193, 193, 193, 0.31)"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "85%",
                                  margin: "0 auto",
                                  "max-width": "600px"
                                }
                              },
                              [
                                _c(
                                  "el-row",
                                  {
                                    staticStyle: {
                                      "margin-bottom": "8px",
                                      "margin-left": "1px",
                                      display: "flex"
                                    },
                                    attrs: { gutter: 20 }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "grid-content",
                                            staticStyle: {
                                              "margin-right": "5px",
                                              "min-width": "100px"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "line-height": "40px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "i18n_contact_person"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "grid-content" },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "240px" },
                                              attrs: {
                                                placeholder: _vm.addPls(
                                                  "i18n_contact_person",
                                                  "input"
                                                )
                                              },
                                              model: {
                                                value: _vm.submitForm.name,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.submitForm,
                                                    "name",
                                                    $$v
                                                  )
                                                },
                                                expression: "submitForm.name"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "grid-content",
                                            staticStyle: {
                                              "margin-left": "10px",
                                              "margin-right": "10px",
                                              "min-width": "80px"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "line-height": "40px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("i18n_contact_info")
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "grid-content" },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "210px" },
                                              attrs: {
                                                placeholder: _vm.addPls(
                                                  "i18n_contact_info",
                                                  "input"
                                                )
                                              },
                                              model: {
                                                value: _vm.submitForm.tel,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.submitForm,
                                                    "tel",
                                                    $$v
                                                  )
                                                },
                                                expression: "submitForm.tel"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  {
                                    staticStyle: { "margin-bottom": "8px" },
                                    attrs: { gutter: 20 }
                                  },
                                  [
                                    _c("el-col", { attrs: { span: 4 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "grid-content" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "line-height": "40px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("i18n_contact_address")
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("el-col", { attrs: { span: 18 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "grid-content" },
                                        [
                                          _c("el-cascader", {
                                            staticStyle: { width: "270px" },
                                            attrs: {
                                              options: _vm.jackCitylist,
                                              placeholder: _vm.addPls(
                                                "i18n_contact_address",
                                                "select"
                                              ),
                                              clearable: "",
                                              props: _vm.props
                                            },
                                            on: { change: _vm.handleChange },
                                            model: {
                                              value: _vm.value,
                                              callback: function($$v) {
                                                _vm.value = $$v
                                              },
                                              expression: "value"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  {
                                    staticStyle: { "margin-bottom": "8px" },
                                    attrs: { gutter: 20 }
                                  },
                                  [
                                    _c("el-col", { attrs: { span: 4 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "grid-content" },
                                        [
                                          _c("div", {
                                            staticStyle: {
                                              "line-height": "40px",
                                              width: "10px",
                                              height: "10px"
                                            }
                                          })
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("el-col", { attrs: { span: 18 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "grid-content" },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              type: "textarea",
                                              rows: "2",
                                              placeholder: _vm.$t(
                                                "i18n_please_enter_the_detailed_location"
                                              )
                                            },
                                            model: {
                                              value: _vm.submitForm.address,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.submitForm,
                                                  "address",
                                                  $$v
                                                )
                                              },
                                              expression: "submitForm.address"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  {
                                    staticStyle: { "margin-bottom": "8px" },
                                    attrs: { gutter: 20 }
                                  },
                                  [
                                    _c("el-col", { attrs: { span: 4 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "grid-content" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "line-height": "40px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("i18n_label"))
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("el-col", { attrs: { span: 18 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "grid-content" },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: _vm.addPls(
                                                "i18n_label",
                                                "input"
                                              )
                                            },
                                            model: {
                                              value: _vm.submitForm.tag,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.submitForm,
                                                  "tag",
                                                  $$v
                                                )
                                              },
                                              expression: "submitForm.tag"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "330px",
                                      margin: "0 auto",
                                      "text-align": "center"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("el-checkbox", {
                                          staticStyle: {
                                            "margin-right": "10px"
                                          },
                                          attrs: { "text-color": "#5F4AFF" },
                                          model: {
                                            value: _vm.submitForm.isdefault,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.submitForm,
                                                "isdefault",
                                                $$v
                                              )
                                            },
                                            expression: "submitForm.isdefault"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "block",
                                              "margin-bottom": "8px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "i18n_set_to_default_address"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: {
                                          background: "#5f4aff",
                                          border: "1px solid #5f4aff",
                                          "border-radius": "5px",
                                          color: "#fff"
                                        },
                                        on: { click: _vm.addAddr }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              this.submitForm.id
                                                ? "i18n_edit"
                                                : "i18n_add"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "info" },
                                        on: {
                                          click: function($event) {
                                            return _vm.showAdd(false)
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("i18n_Close")))]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.edit
                      ? _c(
                          "el-table",
                          {
                            ref: "Table",
                            staticStyle: { width: "100%", overflow: "hidden" },
                            attrs: {
                              size: "mini",
                              height: "300",
                              "tooltip-effect": "dark",
                              data: _vm.tableData,
                              "max-height": "200",
                              "highlight-current-row": "",
                              border: ""
                            },
                            on: { "row-click": _vm.rowClick }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("i18n_Name"),
                                width: "100",
                                align: "center",
                                prop: "name"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("i18n_Phone"),
                                width: "120",
                                align: "center",
                                prop: "tel"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("i18n_contact_address"),
                                "show-overflow-tooltip": "",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(scope.row.parvince) +
                                            "\n              " +
                                            _vm._s(scope.row.city) +
                                            "\n              " +
                                            _vm._s(scope.row.area) +
                                            "\n              " +
                                            _vm._s(scope.row.address) +
                                            "\n            "
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                4200955216
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("i18n_Operation"),
                                align: "center",
                                width: "160"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "mini"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.setDefault(scope.row)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                style: scope.row.isdefault
                                                  ? "color:#604AFF"
                                                  : "color:#9A9A9A"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      scope.row.isdefault
                                                        ? "i18n_Default"
                                                        : "i18n_set_to_default"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "text"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleEdit(
                                                  scope.$index,
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("i18n_edit")))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "mini"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.DeleteTitem(
                                                  scope.$index,
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("i18n_delete"))
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3630198768
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.edit
                      ? _c("el-alert", {
                          staticStyle: { "margin-top": "20px" },
                          attrs: {
                            title: _vm.$t("i18n_Click_line_select_address"),
                            type: "info",
                            center: "",
                            "show-icon": ""
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("i18n_Product_List"),
            width: "950px",
            visible: _vm.goodsTypeShow
          },
          on: {
            "update:visible": function($event) {
              _vm.goodsTypeShow = $event
            }
          }
        },
        [
          _c("div", { staticClass: "typeHeader LR_center" }, [
            _c(
              "div",
              [
                _c(
                  "el-input",
                  {
                    staticClass: "input-with-select",
                    staticStyle: { width: "314px" },
                    attrs: {
                      placeholder: _vm.addPls(
                        "i18n_Product_name_in_Chinese",
                        "input"
                      )
                    },
                    model: {
                      value: _vm.Sgodname,
                      callback: function($$v) {
                        _vm.Sgodname = $$v
                      },
                      expression: "Sgodname"
                    }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          slot: "append",
                          icon: "el-icon-search",
                          type: "primary"
                        },
                        on: {
                          click: function($event) {
                            return _vm.getgoodsData(_vm.Sgodname)
                          }
                        },
                        slot: "append"
                      },
                      [_vm._v(_vm._s(_vm.$t("i18n_Search")))]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "el-select",
                  {
                    ref: "changeFBAgoodtype",
                    staticStyle: { width: "100%" },
                    attrs: {
                      clearable: "",
                      placeholder: _vm.addPls("i18n_Product_Type", "select")
                    },
                    on: {
                      change: function($event) {
                        return _vm.getgoodsData(_vm.Sgodname)
                      }
                    },
                    model: {
                      value: _vm.ThatgoodsID,
                      callback: function($$v) {
                        _vm.ThatgoodsID = $$v
                      },
                      expression: "ThatgoodsID"
                    }
                  },
                  _vm._l(_vm.goodstypelist, function(res) {
                    return _c("el-option", {
                      key: res.id,
                      attrs: { label: res.cnName, value: res.id }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", icon: "el-icon-plus", plain: "" },
                    on: {
                      click: function($event) {
                        return _vm.addgoods()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_New_Products")))]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "countTable",
              staticStyle: { "margin-top": "30px" }
            },
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    border: "",
                    data: _vm.goodsLabel,
                    "tooltip-effect": "dark"
                  },
                  on: { "selection-change": _vm.handleSelectionChange }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55", fixed: "left" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("i18n_Product_name_in_Chinese"),
                      align: "center",
                      width: "120"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [_vm._v(_vm._s(scope.row.namec))]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "namee",
                      label: _vm.$t("i18n_product_name_in_English"),
                      align: "center",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "materialc",
                      align: "center",
                      label: _vm.$t("i18n_Material_in_Chinese")
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "materiale",
                      align: "center",
                      label: _vm.$t("i18n_Material_in_English")
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "purposec",
                      align: "center",
                      label: _vm.$t("i18n_Uses")
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "hsCode",
                      align: "center",
                      label: _vm.$t("i18n_HTS_code")
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goodstype",
                      align: "center",
                      label: _vm.$t("i18n_cargo_classification")
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "sku", align: "center", label: "SKU" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goodstype",
                      align: "center",
                      label: _vm.$t("i18n_electric_or_not")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    scope.row.isHasBattery
                                      ? "i18n_yes"
                                      : "i18n_no"
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goodstype",
                      align: "center",
                      label: _vm.$t("i18n_liquid_power_or_not")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    scope.row.isPowderLiquid
                                      ? "i18n_yes"
                                      : "i18n_no"
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goodstype",
                      align: "center",
                      label: _vm.$t("i18n_magnetic_or_not")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    scope.row.isHasMagnetism
                                      ? "i18n_yes"
                                      : "i18n_no"
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("i18n_Operation"),
                      fixed: "right",
                      align: "center",
                      width: "100"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return scope.row.customerid
                              ? [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.goodsEdit(
                                            scope.$index,
                                            scope.row
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("i18n_edit")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "red" },
                                      attrs: { size: "mini", type: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.delGoodItem(
                                            scope.$index,
                                            scope.row
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("i18n_delete")))]
                                  )
                                ]
                              : undefined
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "qdBtn TB_center",
                  staticStyle: { width: "100%", "margin-top": "50px" }
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "prev, pager, next",
                      total: _vm.goodslisttotal
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "qdBtn TB_center",
                  staticStyle: { width: "100%", "margin-top": "50px" }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.setGoodspush()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("i18n_Confirmation_selection")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("i18n_Create_new_product"),
            visible: _vm.goodstextShow,
            width: "850px"
          },
          on: {
            "update:visible": function($event) {
              _vm.goodstextShow = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "el-form",
                {
                  ref: "addgoodform",
                  staticClass: "LR_center",
                  attrs: {
                    size: "small",
                    model: _vm.addgoodform,
                    "label-width": "110px",
                    "label-position": _vm.lang === "zh" ? "right" : "top"
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "45%" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("i18n_Product_name_in_Chinese"),
                            rules: {
                              required: true,
                              message: "中文品名不能为空",
                              trigger: "blur"
                            }
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.addPls(
                                "i18n_Product_name_in_Chinese",
                                "input"
                              )
                            },
                            model: {
                              value: _vm.addgoodform.namec,
                              callback: function($$v) {
                                _vm.$set(_vm.addgoodform, "namec", $$v)
                              },
                              expression: "addgoodform.namec"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("i18n_Product_Type"),
                            rules: {
                              required: true,
                              message: "商品类型不能为空",
                              trigger: "blur"
                            }
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              ref: "changeFBAgoodtype",
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: _vm.addPls(
                                  "i18n_Product_Type",
                                  "select"
                                )
                              },
                              model: {
                                value: _vm.addgoodform.goodstypeid,
                                callback: function($$v) {
                                  _vm.$set(_vm.addgoodform, "goodstypeid", $$v)
                                },
                                expression: "addgoodform.goodstypeid"
                              }
                            },
                            _vm._l(_vm.goodstypelist, function(res) {
                              return _c("el-option", {
                                key: res.id,
                                attrs: { label: res.cnName, value: res.id }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { label: _vm.$t("i18n_brands") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.addPls("i18n_brands", "input")
                            },
                            model: {
                              value: _vm.addgoodform.brand,
                              callback: function($$v) {
                                _vm.$set(_vm.addgoodform, "brand", $$v)
                              },
                              expression: "addgoodform.brand"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { label: _vm.$t("i18n_HTS_code") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.addPls("i18n_HTS_code", "input")
                            },
                            model: {
                              value: _vm.addgoodform.hsCode,
                              callback: function($$v) {
                                _vm.$set(_vm.addgoodform, "hsCode", $$v)
                              },
                              expression: "addgoodform.hsCode"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { label: _vm.$t("i18n_Material_in_Chinese") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.addPls(
                                "i18n_Material_in_Chinese",
                                "input"
                              )
                            },
                            model: {
                              value: _vm.addgoodform.materialc,
                              callback: function($$v) {
                                _vm.$set(_vm.addgoodform, "materialc", $$v)
                              },
                              expression: "addgoodform.materialc"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("i18n_Product_uses_in_Chinese")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.addPls(
                                "i18n_Product_uses_in_Chinese",
                                "input"
                              )
                            },
                            model: {
                              value: _vm.addgoodform.purposec,
                              callback: function($$v) {
                                _vm.$set(_vm.addgoodform, "purposec", $$v)
                              },
                              expression: "addgoodform.purposec"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("i18n_electric_or_not"),
                            rules: {
                              required: true,
                              message: "请选择是否带电",
                              trigger: "blur"
                            }
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("i18n_please_choose")
                              },
                              model: {
                                value: _vm.addgoodform.isHasBattery,
                                callback: function($$v) {
                                  _vm.$set(_vm.addgoodform, "isHasBattery", $$v)
                                },
                                expression: "addgoodform.isHasBattery"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("i18n_yes"),
                                  value: true
                                }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("i18n_no"),
                                  value: false
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { width: "45%" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("i18n_product_name_in_English"),
                            rules: {
                              required: true,
                              message: "英文品名不能为空",
                              trigger: "blur"
                            }
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.addPls(
                                "i18n_product_name_in_English",
                                "input"
                              )
                            },
                            model: {
                              value: _vm.addgoodform.namee,
                              callback: function($$v) {
                                _vm.$set(_vm.addgoodform, "namee", $$v)
                              },
                              expression: "addgoodform.namee"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { label: "SKU" }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.addPls("SKU", "input") },
                            model: {
                              value: _vm.addgoodform.sku,
                              callback: function($$v) {
                                _vm.$set(_vm.addgoodform, "sku", $$v)
                              },
                              expression: "addgoodform.sku"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("i18n_product_value"),
                            rules: {
                              required: true,
                              message: "货值不能为空",
                              trigger: "blur"
                            }
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.addPls(
                                "i18n_product_value",
                                "input"
                              ),
                              type: "number"
                            },
                            model: {
                              value: _vm.addgoodform.declaredValue,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.addgoodform,
                                  "declaredValue",
                                  _vm._n($$v)
                                )
                              },
                              expression: "addgoodform.declaredValue"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { label: _vm.$t("i18n_material_in_English") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.addPls(
                                "i18n_material_in_English",
                                "input"
                              )
                            },
                            model: {
                              value: _vm.addgoodform.materiale,
                              callback: function($$v) {
                                _vm.$set(_vm.addgoodform, "materiale", $$v)
                              },
                              expression: "addgoodform.materiale"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("i18n_Product_uses_in_English")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.addPls(
                                "i18n_Product_uses_in_English",
                                "input"
                              )
                            },
                            model: {
                              value: _vm.addgoodform.purposee,
                              callback: function($$v) {
                                _vm.$set(_vm.addgoodform, "purposee", $$v)
                              },
                              expression: "addgoodform.purposee"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("i18n_liquid_power_or_not"),
                            rules: {
                              required: true,
                              message: "请选择是否液体/粉末",
                              trigger: "blur"
                            }
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("i18n_please_choose")
                              },
                              model: {
                                value: _vm.addgoodform.isPowderLiquid,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addgoodform,
                                    "isPowderLiquid",
                                    $$v
                                  )
                                },
                                expression: "addgoodform.isPowderLiquid"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("i18n_yes"),
                                  value: true
                                }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("i18n_no"),
                                  value: false
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("i18n_magnetic_or_not"),
                            rules: {
                              required: true,
                              message: "请选择是否带磁",
                              trigger: "blur"
                            }
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("i18n_please_choose")
                              },
                              model: {
                                value: _vm.addgoodform.isHasMagnetism,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addgoodform,
                                    "isHasMagnetism",
                                    $$v
                                  )
                                },
                                expression: "addgoodform.isHasMagnetism"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("i18n_yes"),
                                  value: true
                                }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("i18n_no"),
                                  value: false
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "TB_center",
                  staticStyle: {
                    width: "100%",
                    padding: "30px",
                    "box-sizing": "border-box"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.addgoodtext("addgoodform")
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            _vm.GoodsCategory
                              ? "i18n_confirm_addition"
                              : "i18n_confirm_revision"
                          )
                        )
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("i18n_Download_Template"),
            visible: _vm.excelVisible,
            width: "40%",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.excelVisible = $event
            }
          }
        },
        [
          _c(
            "el-upload",
            {
              staticClass: "upload-demo",
              staticStyle: { "text-align": "center" },
              attrs: {
                "show-file-list": false,
                "on-error": _vm.handleError,
                "on-success": _vm.handleSuccess,
                "before-upload": _vm.handleBeforeUpload,
                "http-request": _vm.uploadSectionFile,
                drag: "",
                action: "",
                multiple: ""
              }
            },
            [
              _c("i", { staticClass: "el-icon-upload" }),
              _vm._v(" "),
              _c("div", { staticClass: "el-upload__text" }, [
                _vm._v("\n        " + _vm._s(_vm.$t("i18n_Drag_file_here_or"))),
                _c("em", [_vm._v(_vm._s(_vm.$t("i18n_click_Upload")))])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.excelVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("i18n_cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-link",
                { attrs: { target: "_blank" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "success" },
                      on: {
                        click: function($event) {
                          return _vm.Getdown()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("i18n_Download_Template")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errorLabel.length > 0,
                    expression: "errorLabel.length > 0"
                  }
                ],
                staticStyle: { width: "100%" },
                attrs: { data: _vm.errorLabel, size: "mini", border: "" }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    width: "80",
                    type: "index",
                    label: _vm.$t("i18n_Serial_number")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    width: "80",
                    prop: "order",
                    label: _vm.$t("i18n_Number_of_rows")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: _vm.$t("i18n_Error_Description") },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v(_vm._s(scope.row.desc))
                          ])
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ]
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("i18n_Example_diagram"),
            visible: _vm.imagesType,
            width: "600px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.imagesType = $event
            }
          }
        },
        [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.imageNum == 1,
                expression: "imageNum == 1"
              }
            ],
            attrs: {
              src: require("../../../static/images/boxdemo.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.imageNum == 2,
                expression: "imageNum == 2"
              }
            ],
            attrs: { src: require("../../../static/images/ponum.png"), alt: "" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "图片管理",
            visible: _vm.pictureManage,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "destroy-on-close": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.pictureManage = $event
            },
            close: _vm.handleClose,
            closed: _vm.uploadDialogClose
          }
        },
        [
          _c(
            "el-upload",
            {
              ref: "pictureManage",
              attrs: {
                action: "",
                "file-list": _vm.fileList,
                "list-type": "picture-card",
                accept: ".png,.jpg,.jpeg",
                "on-preview": _vm.handlePictureCardPreview,
                "http-request": _vm.uploadPicture,
                "on-change": _vm.handleUploadError,
                "on-remove": _vm.handleUploadRemove,
                "before-upload": _vm.beforeImgUpload
              }
            },
            [_c("i", { staticClass: "el-icon-plus" })]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { slot: "footer", type: "primary" },
              on: { click: _vm.clickSavePictureManage },
              slot: "footer"
            },
            [_vm._v("保存")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.previewVisible },
          on: {
            "update:visible": function($event) {
              _vm.previewVisible = $event
            }
          }
        },
        [_c("img", { attrs: { src: _vm.previewUrl, width: "100%", alt: "" } })]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cc3e8586", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc3e8586","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FBAorder/FbaCargo.vue
// module id = null
// module chunks = 